import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-view-batch-tabs',
  templateUrl: './view-batch-tabs.component.html',
  styleUrls: ['./view-batch-tabs.component.scss'],
})
export class ViewBatchTabsComponent implements OnInit {
  @Input() public activeTab: number;
  @Output() public setActiveTab = new EventEmitter<number>();

  constructor() {}

  public ngOnInit() {}
}
